import { selectIsLoading, selectIsLoggedIn } from 'containers/Login/loginSlice'
import { useEffect, useState, useRef, useContext } from 'react'
import ConnectionContext from 'context/connection/Context'
import HeadersManager from 'rest/HeadersManager'
import { useSelector } from 'react-redux'
import { getUuid } from 'utils/uuid'
import { api } from 'rest/urls'

const uuid = getUuid()
const CLOSE_CODE = 3001
const AUTH_URL = `${api}wss/auth`
const WSS_URL = process.env.REACT_APP_WSS || 'wss://api.mmapp.pl/wss'

const useWssConnection = () => {
  const isLogIn = useSelector(selectIsLoggedIn)
  const isLoading = useSelector(selectIsLoading)
  const [messageData, setMessageData] = useState({})
  const isOnline = useContext(ConnectionContext)
  const wssConnection = useRef(null)

  const sendMessage = obj => {
    wssConnection.current?.send(JSON.stringify(obj))
  }

  const parseWssResponse = data => {
    try {
      const parsed = JSON.parse(data)
      const { event, payload } = parsed
      if (event === 'connectionID' && payload.connectionID) {
        HeadersManager.connectionId.set(payload.connectionID)
      }
      setMessageData(parsed)

    } catch (err) {
      console.error('Parser error')
    }
  }

  useEffect(() => {
    let timeout
    const connect = async () => {
      if (wssConnection.current) {
        wssConnection.current.close(CLOSE_CODE)
      }

      const db = process.env.REACT_APP_DB_HEADER
      const token = HeadersManager.jwt.get()
      const headers = new Headers({
        'Accept': 'application/json',
        'X-Client': process.env.REACT_APP_TYPE === 'mm' ? 'MM-Client' : 'Client',
        'X-Client-Hash': uuid,
      })

      if (token) headers.set('Authorization', `Bearer ${token}`)
      if (db) headers.set('X-Database', db)

      const init = {
        method: 'POST',
        headers,
        credentials: 'include',
      }

      try {
        const request = await fetch(AUTH_URL, init)
        const response = request.ok ? await request.json() : {}
        const { result = '', token } = response || {}

        if (result === 'ok' && token) {
          const wss = new WebSocket(WSS_URL)
          wssConnection.current = wss

          wss.onopen = () => {
            HeadersManager.connectionId.destroy()
            sendMessage({ command: 'connectionID' })
            sendMessage({ command: 'token', payload: { token } })
          }

          wss.onclose = (socket) => {
            HeadersManager.connectionId.destroy()
            if (socket.code !== CLOSE_CODE) {
              timeout = setTimeout(connect, 5000)
            }
          }

          wss.onmessage = e => {
            parseWssResponse(e.data)
          }

        } else {
          throw Error('wrong result')
        }

      } catch (err) {
        console.error(`Error: ${err}`)
      }
    }

    if (!isLoading && isOnline) connect()
    return () => {
      wssConnection.current?.close(CLOSE_CODE)
      if (timeout) clearTimeout(timeout)
    }
  }, [isLoading, isLogIn, isOnline])

  return {
    messageData,
    sendMessage
  }
}

export default useWssConnection
